const baseURL = process.env.VUE_APP_API_URL

const getCookie = (name) => {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    
    if (parts.length === 2) {
        return parts.pop().split(';').shift()
    }
}

export const apiFetch = async (endpoint, options = {}) => {

    const xsrfToken = getCookie('XSRF-TOKEN')

    return fetch(`${baseURL}${endpoint}`, {
        credentials: 'include',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            'X-XSRF-TOKEN': decodeURIComponent(xsrfToken || ''),
            'X-Requested-With': 'XMLHttpRequest',
            ...(options.headers || {})
        }
    })
}